export default "__VITE_ASSET__D$7IPzU9__";